export default [
  {
    title: 'เช็คสถานะ',
    route: 'customer-shipping-status',
    icon: 'MapPinIcon',
  },
  {
    title: 'บิลค่าขนส่ง',
    route: 'customer-shipping-delivery',
    icon: 'FileTextIcon',
  },
  {
    title: 'วิธีการสั่งของ',
    route: 'customer-shipping-howtoorder',
    icon: 'BookOpenIcon',
  },
]
